<template>
  <main class="pr pb pl">
    <template v-for="section in site.sections">
      <intro v-if="section.uid === 'home'" :key="section.uid" />
      <festival v-if="section.uid === 'festival'" :key="section.uid" />
      <podcast v-if="section.uid === 'podcasts'" :key="section.uid" />
      <!-- <testimonials v-if="section.uid === 'testimonials'" :key="section.uid" /> -->
      <gallery v-if="section.uid === 'gallery'" :key="section.uid" />
      <program v-if="section.uid === 'program'" :key="section.uid" />
      <partner v-if="section.uid === 'partner'" :key="section.uid" />
      <tickets v-if="section.uid === 'tickets'" :key="section.uid" />
      <archive v-if="section.uid === 'archive'" :key="section.uid" />
      <curators v-if="section.uid === 'curators'" :key="section.uid" />
      <press v-if="section.uid === 'press'" :key="section.uid" />
      <!-- <contact v-if="section.uid === 'contact'" :key="section.uid" /> -->
      <support v-if="section.uid === 'support'" :key="section.uid" />
      <organization v-if="section.uid === 'organization'" :key="section.uid" />
      <question v-if="section.uid === 'question'" :key="section.uid" />
      <newsletter v-if="section.uid === 'newsletter'" :key="section.uid" />
    </template>
    <section v-if="$i18n.locale === 'en'" class="small delay half">
      <p>
        Website: <a href="https://sava.world" target="_blank">sava</a> and
        <a href="https://fm-a.dk" target="_blank">Frederik Mahler-Andersen</a>
      </p>
    </section>
    <section v-if="$i18n.locale === 'de'" class="small delay half">
      <p>
        Webseite: <a href="https://sava.world" target="_blank">sava</a> und
        <a href="https://fm-a.dk" target="_blank">Frederik Mahler-Andersen</a>
      </p>
    </section>
  </main>
</template>

<script>
import { mapState } from "vuex";
const Intro = () =>
  import(/* webpackChunkName: "Intro" */ "@/components/Intro.vue");
const Festival = () =>
  import(/* webpackChunkName: "Festival" */ "@/components/Festival.vue");
const Podcast = () =>
  import(/* webpackChunkName: "Podcast" */ "@/components/PodcastList.vue");
// const Testimonials = () =>
//   import(
//     /* webpackChunkName: "Testimonials" */ "@/components/Testimonials.vue"
//   );
const Gallery = () =>
  import(/* webpackChunkName: "Gallery" */ "@/components/Gallery.vue");
const Program = () =>
  import(/* webpackChunkName: "Program" */ "@/components/Program.vue");
const Partner = () =>
  import(/* webpackChunkName: "Partner" */ "@/components/Partner.vue");
const Tickets = () =>
  import(/* webpackChunkName: "Tickets" */ "@/components/Tickets.vue");
const Archive = () =>
  import(/* webpackChunkName: "Archive" */ "@/components/Archive.vue");
const Curators = () =>
  import(/* webpackChunkName: "Curators" */ "@/components/Curators.vue");
const Press = () =>
  import(/* webpackChunkName: "Press" */ "@/components/Press.vue");
// const Contact = () =>
//   import(/* webpackChunkName: "Contact" */ "@/components/Contact.vue");
const Support = () =>
  import(/* webpackChunkName: "Support" */ "@/components/Support.vue");
const Organization = () =>
  import(
    /* webpackChunkName: "Organization" */ "@/components/Organization.vue"
  );
const Question = () =>
  import(/* webpackChunkName: "Question" */ "@/components/Question.vue");
const Newsletter = () =>
  import(/* webpackChunkName: "Newsletter" */ "@/components/Newsletter.vue");
export default {
  name: "home",
  components: {
    Intro,
    Festival,
    Podcast,
    // Testimonials,
    Gallery,
    Program,
    Partner,
    Tickets,
    Archive,
    Curators,
    Press,
    // Contact,
    Support,
    Organization,
    Question,
    Newsletter,
  },
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null,
    };
  },
  mounted() {
    if (this.site && this.$route.params.pathMatch) {
      if (this.$route.hash) {
        setTimeout(() => {
          this.$scrollTo(this.$route.hash, 1000);
        }, 3000);
      } else {
        setTimeout(() => {
          this.$scrollTo("#" + this.$route.params.pathMatch, 1000);
        }, 3000);
      }
    } else {
      if (this.$route.hash) {
        setTimeout(() => {
          this.$scrollTo(this.$route.hash, 1000);
        }, 3000);
      }
    }
  },
  computed: mapState(["site"]),
};
</script>
